import api from './data.services'
import { authService } from './'

const appointmentsMedical = 'medicals/appointments'
const appointmentsSummaryUpcomingsSrv = `${appointmentsMedical}/upcomings/summaries`
const appointmentsSummaryAllSrv = `${appointmentsMedical}/histories/summaries`
const appointmentsUpcomingsSrv = `${appointmentsMedical}/upcomings`
const appointmentsAllSrv = `${appointmentsMedical}/histories`
const appointmentsCancelSrv = `${appointmentsMedical}/cancel`
const appointmentsDocumentsSrv = `documents/${appointmentsMedical}`

const getSummaryUpcomings = async () => {
  try {
    const resp: any = await api.get(`${appointmentsSummaryUpcomingsSrv}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : {})
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al obtener resumen de citas médicas recientes!'
    }
  }
}

const getSummaryAll = async () => {
  try {
    const resp: any = await api.get(`${appointmentsSummaryAllSrv}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : {})
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al obtener resumen de citas médicas recientes!'
    }
  }
}

const getUpcomings = async (patientId?: string) => {
  try {
    const resp: any = await api.get(`${appointmentsUpcomingsSrv}${patientId ? '/' + patientId : ''}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : {})
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al obtener citas médicas!'
    }
  }
}

const getAll = async (patientId?: string) => {
  try {
    const resp: any = await api.get(`${appointmentsAllSrv}${patientId ? '/' + patientId : ''}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : {})
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al obtener citas médicas!'
    }
  }
}

const getDocuments = async () => {
  try {
    const resp: any = await api.get(`${appointmentsDocumentsSrv}`, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data && resp.data.documentMedicalAppointments ? resp.data.documentMedicalAppointments : [])
    }
  } catch(error) {
    return {
      status: 'Error',
      data: [],
      message: 'Error server al obtener documentos de citas médicas!'
    }
  }
}

const putAppointmentCancel = async (appointmentId: string) => {
  try {
    const resp: any = await api.put(`${appointmentsCancelSrv}`, { id_appointment: appointmentId }, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : {})
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al obtener citas médicas!'
    }
  }
}

const postDocument = async (document: any) => {
  try {
    const resp: any = await api.post(`${appointmentsDocumentsSrv}/requests`, document, authService.getToken())

    return {
      status: 'Ok',
      data: (resp && resp.data ? resp.data : {})
    }
  } catch(error) {
    return {
      status: 'Error',
      data: {},
      message: 'Error server al obtener documento!'
    }
  }
}

export const appointmentService = {
  getSummaryUpcomings,
  getSummaryAll,
  getUpcomings,
  getAll,
  getDocuments,
  putAppointmentCancel,
  postDocument
}